<template>
  <div v-if="operator === 'not_empty'" class="input-group">
  </div>

  <div v-if="operator === 'relative'" class="input-group">
    <input class="form-control" v-model="start" :name="'filter_' + fieldKey + '[start]'" type="text" placeholder="Example: -30d (last 30 days)">
    <span class="input-group-addon">to</span>
    <input class="form-control" v-model="end" :name="'filter_' + fieldKey + '[end]'" type="text" placeholder="Example: 0d (today)">
  </div>

  <div v-if="operator === 'absolute'" class="row">

    <div class="col-md-6">
      <datepicker
        v-model="start"
        :name="'filter_' + fieldKey + '[start]'"
        position="left"
        placeholder="Start date">
      </datepicker>
    </div>

    <div class="col-md-6">
      <datepicker
        v-model="end"
        :name="'filter_' + fieldKey + '[end]'"
        position="left"
        placeholder="End date">
      </datepicker>
    </div>

  </div>
</template>

<script>
export default {

  props: {
    operator: {type: String, required: true},
    fieldKey: {type: String, required: true},
    fieldValue: {type: String, default: ''},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      start: this.fieldValue.start ?? '',
      end: this.fieldValue.end ?? '',
    }
  },

  watch: {
    operator: {
      handler(value) {
        this.start = '';
        this.end = '';
      }
    }
  }

}
</script>
